<template>
  <NuxtLayout name="activity">
    <div class="page-reset w">
      <div
        v-if="steps === 2"
        class="success_tips"
      >
        <img
          src="@/assets/images/success.png"
          alt=""
        >
        <div class="desc">
          密码重置成功
        </div>
        <p>{{ downtime }} 秒后自动跳转至网站首页</p>
        <el-button
          class="btn"
          type="primary"
          @click="toHome"
        >
          立即前往
        </el-button>
      </div>
      <div
        v-else
        class="form_container"
      >
        <div class="head_top">
          <span class="title">重置密码</span>
          <NuxtLink to="/login">
            返回账号登录
          </NuxtLink>
        </div>
        <el-steps
          class="steps"
          :active="steps"
          align-center
        >
          <el-step title="验证手机号码" />
          <el-step title="设置新密码" />
          <el-step title="密码重置成功" />
        </el-steps>
        <div v-show="steps === 0">
          <el-form
            ref="formRef"
            :model="form"
            :rules="rules"
            size="large"
            class="form"
          >
            <el-form-item prop="telCode">
              <client-only>
                <el-select
                  v-model="form.telCode"
                  filterable
                  placeholder="请选择"
                >
                  <template #prefix>
                    <span>国家/地区</span>
                  </template>
                  <el-option
                    v-for="item in opts.TelCodeEnum"
                    :key="item.code"
                    :label="item.desc"
                    :value="item.code"
                  >
                    <span style="float: left">{{ item.standardDesc }}</span>
                    <span
                      style="
                        float: right;
                        color: var(--el-text-color-secondary);
                        font-size: 13px;
                      "
                    >{{ item.codeDesc }}</span>
                  </el-option>
                </el-select>
              </client-only>
            </el-form-item>
            <el-form-item prop="phone">
              <el-input
                v-model="form.phone"
                placeholder="请输入手机号"
              >
                <template #prefix>
                  <el-icon class="el-input__icon">
                    <iphone />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="verificationCode">
              <el-input
                v-model="form.verificationCode"
                placeholder="请输入验证码"
              >
                <template #prefix>
                  <span class="iconfont icon-icon_Code" />
                </template>
                <template #suffix>
                  <el-button
                    type="text"
                    @click="getCode"
                  >
                    {{ txt }}
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <el-button
            class="submit"
            type="primary"
            @click="next(formRef)"
          >
            下一步
          </el-button>
        </div>
        <div v-show="steps === 1">
          <el-form
            ref="pwdFormRef"
            :model="pwdForm"
            :rules="pwdRules"
            size="large"
            class="form"
          >
            <el-form-item prop="loginPwd">
              <el-input
                v-model="pwdForm.loginPwd"
                type="password"
                show-password
                placeholder="密码由6-20位大写和小写字母和数字组成"
              />
            </el-form-item>
            <el-form-item prop="confirmPwd">
              <el-input
                v-model="pwdForm.confirmPwd"
                type="password"
                show-password
                placeholder="请再次输入密码"
              />
            </el-form-item>
          </el-form>
          <el-button
            v-if="isReturn"
            class="submit"
            type="primary"
            @click="prev()"
          >
            返回
          </el-button>
          <el-button
            v-else
            class="submit"
            type="primary"
            @click="submitForm(pwdFormRef)"
          >
            确认
          </el-button>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>
<script setup>
import { ElMessage } from 'element-plus'
import { Iphone, Lock } from '@element-plus/icons-vue'
import { useUserStore } from '@/stores/user'
import { getMsg, userResetLoginPwd } from '@/api/user'
import cookie from '@/utils/cookies'
const cookieData = cookie.getShop()
useHead({
  title: '忘记密码-' + cookieData.shopName
})

const store = useUserStore()
const { getEnumList, setToken, getUserView } = store
const router = useRouter()

const steps = ref(0)
const opts = reactive({
  TelCodeEnum: ''
})

const formRef = ref('')
const form = reactive({
  telCode: '86',
  phone: '',
  verificationCode: ''
})
const rules = reactive({
  telCode: [
    {
      required: true,
      message: '请选择国家/地区',
      trigger: 'change'
    }
  ],
  phone: [
    {
      required: true,
      message: '请输入手机号',
      trigger: 'blur'
    }
  ],
  verificationCode: [
    {
      required: true,
      message: '请输入验证码',
      trigger: 'blur'
    }
  ]
})

const pwdFormRef = ref('')
const pwdForm = reactive({
  loginPwd: '',
  confirmPwd: ''
})
const checkPwd = (rule, value, callback) => {
  const passwordreg =
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/
  if (!value) {
    return callback(new Error('请输入新的登录密码'))
  }
  if (!passwordreg.test(value) || value.length > 20 || value.length < 6) {
    callback(new Error('密码必须由6-20位大写和小写字母和数字组成'))
  } else {
    callback()
  }
}
const checkConfirmPwd = (rule, value, callback) => {
  if (!value) {
    callback('请再次输入密码')
  } else if (value !== pwdForm.loginPwd) {
    callback('确认密码与新的登录密码不一致')
  } else {
    callback()
  }
}
const pwdRules = reactive({
  loginPwd: [
    {
      validator: checkPwd,
      trigger: 'blur'
    }
  ],
  confirmPwd: [
    {
      validator: checkConfirmPwd,
      trigger: 'blur'
    }
  ]
})

onMounted(() => {
  getEnumList('TelCodeEnum', 'arr').then((res) => {
    opts.TelCodeEnum = res
  })
})

const txt = ref('获取验证码')
const disabled = ref(false)
const timeOut = () => {
  let num = 60
  disabled.value = true
  txt.value = num
  const nt = setInterval(() => {
    if (num <= 0) {
      clearInterval(nt)
      disabled.value = false
      txt.value = '重新获取'
    } else {
      num--
      txt.value = num + 's'
    }
  }, 1000)
}

const getCode = () => {
  if (disabled.value) return
  if (!/^1\d{10,10}$/.test(parseInt(form.phone))) {
    ElMessage.error('请输入正确的手机号')
    return false
  }
  getMsg({
    phone: form.phone,
    telCode: form.telCode,
    verificationCodeType: 3
  }).then((res) => {
    timeOut()
  })
}

const prev = () => {
  if (steps.value === 1) {
    steps.value = 0
  } else {
    return false
  }
}

const next = (formEl) => {
  if (!formEl) return
  formEl.validate((valid) => {
    if (valid) {
      steps.value = 1
    }
  })
}

const isReturn = ref(false)
const downtime = ref(5)
const submitForm = (formEl) => {
  if (!formEl) return
  formEl.validate((valid) => {
    if (valid) {
      userResetLoginPwd({
        ...form,
        ...pwdForm
      }).then((res) => {
        if (res) {
          steps.value = 2
          const timer = setInterval(() => {
            downtime.value -= 1
            if (downtime.value < 1) {
              clearInterval(timer)
              toHome()
            }
          }, 1000)
        }
      }).catch(err => {
        isReturn.value = true
      })
    } else {
      return false
    }
  })
}
const toHome = () => {
  router.push({ path: '/' })
}
</script>
<style lang="scss">
.page-reset {
  .el-step__title {
    font-size: 12px;
    font-weight: 400;
  }
  .el-step__icon.is-text {
    .el-step__icon-inner {
      //display: none;
    }
    .dot {
      width: 14px;
      height: 14px;
      background: #EBEEF5;
      border-radius: 50%;
    }
  }
  .el-step__line {
    background: #EBEEF5;
  }
  .is-process, .is-finish {
    .el-step__icon.is-text .dot {
      background: #2256F6;
    }
    .el-step__line {
      background: #2256F6;
    }

  }
  .el-step.is-center .el-step__line {
    left: 0;
    right: 0;
  }
  .el-step:last-of-type .el-step__line {
    display: block;
    right: 50%;
  }
  .el-steps .el-step:first-child .el-step__line {
    left: 50%;
  }
  .el-select {
    width: 100%;
    .el-input__inner {
      text-align: right;
    }
  }
  .el-input__icon {
    color: #333;
  }
}
</style>
<style lang="scss" scoped>
.page-reset {
  height: calc(100vh - 66px - 70px);
  display: flex;
  justify-content: center;
  align-items: center;
  .form_container {
    width: 680px;
    height: 460px;
    border-radius: 10px;
    background: #fff;
    padding: 30px;
    position: relative;
    text-align: center;
    .head_top {
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 16px;
        font-weight: 700;
      }
    }
    .steps {
      margin-top: 30px;
    }
    .form {
      margin: 30px auto 0;
      width: 380px;
    }
    span {
      color: #333;
    }
    .submit {
      width: 380px;
      height: 50px;
    }
  }
  .success_tips {
    width: 680px;
    height: 460px;
    border-radius: 10px;
    background: #fff;
    padding: 70px 0;
    text-align: center;
    img {
      margin: auto;
    }
    .desc {
      font-size: 16px;
      margin-top: 20px;
    }
    p {
      color: #999;
      margin-top: 10px;
    }
    .btn {
      width: 380px;
      height: 50px;
      margin-top: 50px;
      font-size: 14px;
    }
  }
}
</style>
